import React,{useState ,useEffect} from "react";

import "./WeatherForecast.css";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";



export default function WeatherForecast(props){
   let [loaded,setLoaded]=useState(false);
   let[forecast,setForecast]=useState(null);

   useEffect(()=>{
    setLoaded(false);
  },[props.coordinates]);


   function handleResponse(response){
    console.log(response.data);
    setForecast(response.data.daily);
    setLoaded(true);
   }
   
   if (loaded){
    console.log(forecast);
    return (
    <div className="WeatherForecast">
    <div className="row">
        {forecast.map(function(dailyForecast, index){
        if(index < 5){
            return(
                <div className="col" key={index}> 
               <WeatherForecastDay  data={dailyForecast} />   
               </div>
            );
        }else{
            return null;
        }
        })}
        
     </div>
   </div>
 );

}else{
    let apiKey="bd79ao40tde3dec118ca46bc3e6dd55f";
    let longitude=props.coordinates.longitude;
    let latitude =props.coordinates.latitude;
    let apiUrl=`https://api.shecodes.io/weather/v1/forecast?lon=${longitude}&lat=${latitude}&key=${apiKey}`;
    console.log(apiUrl);
   
    axios.get(apiUrl).then(handleResponse);
    return null;   
 }
}